import { NgModule } from "@angular/core";
import { WindowComponent } from "./window/window.component";
import { WindowTitleBarComponent } from "./window/window-titlebar.component";
import { DraggableDirective } from './window/draggable.directive';
import { ResizeHandleDirective } from './window/window-resize-handle.directive';
import { WindowMaximizeActionDirective } from './window/actions/window-maximize-action.directive';
import { WindowMinimizeActionDirective } from './window/actions/window-minimize-action.directive';
import { WindowCloseActionDirective } from './window/actions/window-close-action.directive';
import { WindowRestoreActionDirective } from './window/actions/window-restore-action.directive';
import { WindowService } from './window/window.service';
import { WindowContainerService } from './window/window-container.service';
import { WindowContainerDirective } from './window/window-container.directive';
import { SharedModule, SHARED_DIRECTIVES } from './shared.module';
var WINDOW_DIRECTIVES = [
    DraggableDirective,
    ResizeHandleDirective,
    WindowComponent,
    WindowTitleBarComponent,
    WindowCloseActionDirective,
    WindowMinimizeActionDirective,
    WindowMaximizeActionDirective,
    WindowRestoreActionDirective
];
var ENTRY_COMPONENTS = [
    WindowComponent,
    WindowTitleBarComponent
];
var exportedModules = [
    WindowComponent,
    WindowCloseActionDirective,
    WindowMinimizeActionDirective,
    WindowMaximizeActionDirective,
    WindowRestoreActionDirective,
    WindowTitleBarComponent
];
/**
 * Represents the [NgModule](https://angular.io/docs/ts/latest/guide/ngmodule.html)
 * definition for the Window component.
 */
var WindowModule = /** @class */ (function () {
    function WindowModule() {
    }
    WindowModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [WINDOW_DIRECTIVES, WindowContainerDirective],
                    entryComponents: [ENTRY_COMPONENTS],
                    exports: [exportedModules, SHARED_DIRECTIVES, WindowContainerDirective],
                    imports: [SharedModule],
                    providers: [WindowContainerService, WindowService]
                },] },
    ];
    /** @nocollapse */
    WindowModule.ctorParameters = function () { return []; };
    return WindowModule;
}());
export { WindowModule };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-dialog/dist/es/window.module.js
// module id = ../../../../@progress/kendo-angular-dialog/dist/es/window.module.js
// module chunks = vendor